
<scroll-area class="work-area workarea fds" ref="workArea">
  <div class="object-model-default-actions">
    <base-object-model-action
        class="object-model-default-action"
        v-for="defaultAction in objectModelDefaultActions"
        :key="defaultAction.client_id"
        :object-model-action="defaultAction"
    ></base-object-model-action>
  </div>
  <hr>
  <div class="object-model-actions">
    <template v-if="objectModelActions.length">
      <base-object-model-action
        class="object-model-action om-action-draggable om-action-droppable"
        v-for="objectModelAction in objectModelActions"
        :key="objectModelAction.client_id"
        :object-model-action="objectModelAction"
        @remove="removeAction"></base-object-model-action>
    </template>
    <div v-else class="drop-in-zone empty">
      <p><b>Drag and Drop</b> action types here.</p>
    </div>
  </div>
</scroll-area>
